import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ae2c462a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ae2c462a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2c462a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2c462a')) {
      api.createRecord('ae2c462a', component.options)
    } else {
      api.reload('ae2c462a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ae2c462a&scoped=true&", function () {
      api.rerender('ae2c462a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cm6A52qOq9HJ/JS/comp/PopupDialog.vue"
export default component.exports